import docDorsoPic from '../../../assets/images/CIDorso_py.svg'
import docFrentePic from '../../../assets/images/CIFrente_py.svg'
import docSelfiePic from '../../../assets/images/doc_selfie_frente.svg'
import OpenDeviceCamera from '../../../components/OpenDeviceCamera'

interface Props {
  side: string
  photo?: boolean
}

const ExtLanding = ({ side, photo }: Props) => {
  const image = side === 'front' ? docFrentePic : docDorsoPic
  const label = side === 'front' ? 'frente' : 'dorso'
  const recommendations =
    side === 'front' ? (
      <>
        Te recomendamos que apoyes <br /> el documento en un fondo oscuro <br /> y no uses flash.
      </>
    ) : (
      <>
        Si el cliente presentó un pasaporte, <br /> sacá foto a la segunda hoja.
      </>
    )

  const documentCapture = (
    <div className="landing-container">
      <img id="img-document" src={image} style={{ maxHeight: '150px' }} alt="take document" />
      <h2 id="fotografia-dorso">
        Fotografía <b style={{ color: '#ef3829' }}>{label}</b> <br /> del documento
      </h2>
      <p className="recomendaciones">{recommendations}</p>
      <OpenDeviceCamera
        label="Continuar"
        imageCapture={(event: any) => {
          return true
        }}
        documentSide={side}
      />
    </div>
  )

  const photoCapture = (
    <div className="landing-container">
      <img id="img-client-with-document" src={docSelfiePic} style={{ maxHeight: '150px' }} alt="take client selfie" />
      <h2 id="fotografia-cliente">
        Tomá una foto del <b style={{ color: '#ef3829' }}>cliente</b> <br /> con su
        <b style={{ color: '#ef3829' }}> documento</b>
      </h2>
      <p className="recomendaciones">
        Recordá solicitarle que coloque su <br /> pasaporte o cédula de frente, cerca <br /> del rostro y sin taparlo.
      </p>
      <OpenDeviceCamera
        label="Continuar"
        imageCapture={(event: any) => {
          return true
        }}
        documentSide={side}
      />
    </div>
  )

  return (
    <main className="landing">
      {!photo && documentCapture}
      {photo && photoCapture}
    </main>
  )
}

export default ExtLanding
